import { useEffect, useState } from 'react';

/**
 * The current time, as state that re-renders on a tick.
 *
 * Reading `Date.now()` during render is impure: the value changes between renders
 * for no reason React can see, so a component that shows "ends in 24 min" or
 * "active now" would be right by accident and wrong whenever nothing else caused a
 * re-render. This makes the clock an explicit input instead.
 *
 * A minute is the right default for anything measured in minutes or days — a
 * countdown that ticks every second is a countdown that repaints 60× more often
 * than anybody can read it.
 */
const DEFAULT_INTERVAL_MS = 60_000;

export function useNow(intervalMs: number = DEFAULT_INTERVAL_MS): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);

  return now;
}
